import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Discount(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.387.5c1.654 0 3 1.346 3 3v8.082a2.98 2.98 0 01-.878 2.121l-9.307 9.307a2.99 2.99 0 01-2.122.877 2.99 2.99 0 01-2.12-.877L.876 14.928a3.002 3.002 0 010-4.242l9.307-9.307A2.982 2.982 0 0112.305.5h8.082zm0 2h-8.082c-.263 0-.52.106-.707.293L2.291 12.1a1.003 1.003 0 000 1.414l8.082 8.082a1.004 1.004 0 001.415 0l9.307-9.307a.993.993 0 00.292-.707V3.5c0-.552-.449-1-1-1zM14.23 15.514a1.501 1.501 0 01-2.804 1.068 1.501 1.501 0 012.804-1.068zm2.285-5.076a1 1 0 01-.574 1.293l-8.096 3.115a1.004 1.004 0 01-1.292-.575 1 1 0 01.574-1.293l8.096-3.114a1.003 1.003 0 011.292.574zm-5.034-2.15a1.503 1.503 0 01-.87 1.936 1.502 1.502 0 01-1.066-2.805 1.503 1.503 0 011.936.869zm7.427-4.812a1.503 1.503 0 011.506 1.494 1.503 1.503 0 01-1.495 1.506 1.501 1.501 0 01-.011-3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoDiscount = React.memo(Discount);
export default MemoDiscount;